export default function SeenIcon({ status,type }) {
    // status can be: "sent", "delivered", "seen"
    const color =
    status === "seen" ? "#2E7D32" :type === "mine"?"white":"#999"; // green when seen, gray otherwise
  
  if (status === "sent") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <polyline points="20 6 9 17 4 12" />
      </svg>
    );
  }

  if (status === "delivered" || status === "seen") {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        {/* First tick */}
        <polyline points="17 6 9 14 5 10" />
        {/* Second tick slightly offset */}
        <polyline points="22 6 14 14 10 10" />
      </svg>
    );
  }

  return null;
}